import { FC, PropsWithChildren } from 'react';
import useStompSubscriber from 'src/hooks/useStomp';
import useWebviewFont from './useWebviewFont';
import useWebviewLoginResponse from './useWebviewLoginResponse';
const WebviewWrapper: FC<PropsWithChildren> = ({
  children
}) => {
  useWebviewFont();
  useWebviewLoginResponse();
  useStompSubscriber();
  return <>{children}</>;
};
export default WebviewWrapper;